module.exports = __webpack_public_path__ + "img/logo-branchenzentrum-retina.27ef1772.png";